import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { Reveal } from "./Reveal";

const GEO_URL = "/data/world-110m.json";
const PLACES = [
  { id: "380", key: "italy", coords: [12.5, 42.5], anchor: "end", dx: -10 },
  { id: "686", key: "senegal", coords: [-14.5, 14.5], anchor: "end", dx: -10 },
];
const HIGHLIGHT = new Set(PLACES.map((p) => p.id));

export const WhereWeWork = ({ c }) => (
  <section className="bg-[#F6F3EE] py-12 md:py-16" data-testid="where-we-work">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Reveal>
        <span className="font-display font-bold tracking-widest text-xs text-forest">{c.kicker}</span>
        <h2 className="mt-4 font-display font-bold tracking-tight text-3xl md:text-5xl text-ink max-w-3xl">{c.title}</h2>
        <p className="mt-5 max-w-2xl text-stone leading-relaxed">{c.intro}</p>
      </Reveal>
      <Reveal className="mt-8 grid gap-8 lg:grid-cols-12 items-center">
        <div className="lg:col-span-8 overflow-hidden rounded-[2rem] border border-border bg-bone">
          <ComposableMap projection="geoNaturalEarth1" projectionConfig={{ scale: 190, center: [10, 10] }} width={900} height={480} style={{ width: "100%", height: "auto" }}>
            <Geographies geography={GEO_URL}>
              {({ geographies }) =>
                geographies.map((geo) => {
                  const active = HIGHLIGHT.has(geo.id);
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill={active ? "#D94833" : "#e6e1d8"}
                      stroke="#f7f4ee"
                      strokeWidth={0.5}
                      style={{ default: { outline: "none" }, hover: { outline: "none", fill: active ? "#A83624" : "#d9d3c7" }, pressed: { outline: "none" } }}
                    />
                  );
                })
              }
            </Geographies>
            {PLACES.map((p) => (
              <Marker key={p.key} coordinates={p.coords}>
                <circle r={9} fill="#D94833" opacity={0.25}>
                  <animate attributeName="r" values="6;14;6" dur="2.4s" repeatCount="indefinite" />
                  <animate attributeName="opacity" values="0.35;0;0.35" dur="2.4s" repeatCount="indefinite" />
                </circle>
                <circle r={4} fill="#D94833" stroke="#fff" strokeWidth={1.5} />
                <text textAnchor={p.anchor} x={p.dx} y={4} className="font-display" style={{ fontSize: 13, fontWeight: 700, fill: "#1A1714" }}>
                  {c.places[p.key].name}
                </text>
              </Marker>
            ))}
          </ComposableMap>
        </div>
        <ul className="lg:col-span-4 space-y-6" data-testid="where-we-work-list">
          {PLACES.map((p, i) => (
            <li key={p.key} className="border-l-2 border-terracotta pl-5">
              <span className="font-display text-xs tracking-widest text-terracotta">0{i + 1}</span>
              <h3 className="mt-1 font-display font-bold text-xl text-ink">{c.places[p.key].name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-stone">{c.places[p.key].desc}</p>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
